import { Model } from './model'

// until https://github.com/Microsoft/TypeScript/pull/15486 is merged
// type is defined separately from const object
export type MenuItemType = 'hub_redirect' | 'redirect' | 'event' | 'divider'
export const MenuItemType = {
  HUB_REDIRECT: 'hub_redirect' as MenuItemType, // default type, creates external link to parent domain
  REDIRECT: 'redirect' as MenuItemType, // creates external link
  EVENT: 'event' as MenuItemType, // calls internal app event
  DIVIDER: 'divider' as MenuItemType // creates horizontal divider line
}

export type MenuItemTarget = 'blank' | 'self'
export const MenuItemTarget = {
  BLANK: 'blank' as MenuItemTarget, // default target
  SELF: 'self' as MenuItemTarget
}

export class MenuItem extends Model {
  icon: string
  title: string
  action: string
  type: MenuItemType
  target: MenuItemTarget

  constructor(obj = {}) {
    obj['type'] = obj['type'] || MenuItemType.HUB_REDIRECT

    if (!obj['target']) {
      obj['target'] = MenuItemTarget.SELF
    }

    super(obj)
  }
}
